import React, { FC } from "react";
import { Button } from "@telia/teddy";
import Cookies from "js-cookie";
import _size from "lodash/size";
import { connect, useDispatch } from "react-redux";
import {
    FORM_ID,
    GTM_ECOMMERCE_STEP,
    CART_ITEM_TYPE as CART_ITEM_TYPE_CONST,
    DeliveryType,
} from "../../../../../../constants";
import PAGES from "../../../../../../constants/pages";
import { ICartItem, RootState } from "../../../../../../models";
import { trackCheckoutAndNavigate } from "../../../../google-analytics";
import { selectors as LOADING_SELECTORS } from "../../../../loading";
import { selectors as NAVIGATION_SELECTORS } from "../../../../navigation";
import { fetchDeliveryAndPaymentMethods } from "../../../state/actions/combinedActions";
import { checkoutPayment } from "../../../state/actions/paymentActions";
import {
    isDigitalDelivery as isDigitalDeliverySelector,
    getTotalPaymentPrice,
} from "../../../state/selectors/combinedSelectors";
import {
    hasDraftMobileSubscriptions as hasDraftMobileSubscriptionsSelector,
    hasOnlyServiceSubscriptions as hasOnlyServiceSubscriptionsSelector,
    getAllItemsOfType,
} from "../../../state/selectors/cartSelectors";
import * as DELIVERY_INFO_SELECTORS from "../../../state/selectors/deliveryInfoSelectors";
import { showAddMemberInputFields as showAddMemberInputFieldsSelector } from "../../../state/selectors/formSelectors";
import TEXT from "../../../text-consts";

interface StateProps {
    deliveryInfoCode?: string;
    deliveryInfoNote?: string;
    deliveryInfoType?: DeliveryType;
    draftSubscriptions: ICartItem[];
    hasDraftSubscriptions: boolean;
    hasOnlyServiceSubscriptions: boolean;
    isFetchingData: boolean;
    isDigitalDelivery: boolean;
    isNavigating: boolean;
    showAddMemberInputFields: boolean;
    totalPaymentPrice: number;
}

type AddMemberContinueButtonProps = StateProps;

const AddMemberContinueButton: FC<AddMemberContinueButtonProps> = ({
    isFetchingData,
    isNavigating,
    showAddMemberInputFields,
    hasDraftSubscriptions,
    draftSubscriptions,
    totalPaymentPrice,
    hasOnlyServiceSubscriptions,
    isDigitalDelivery,
    deliveryInfoCode,
    deliveryInfoNote,
    deliveryInfoType,
}) => {
    const dispatch = useDispatch();
    const shouldSubmitorder = hasOnlyServiceSubscriptions && totalPaymentPrice <= 0;

    const handleOnContinue = async () => {
        if (!hasDraftSubscriptions || _size(draftSubscriptions) === 1) {
            if (shouldSubmitorder) {
                await dispatch(fetchDeliveryAndPaymentMethods());
                await dispatch(checkoutPayment(deliveryInfoType, deliveryInfoCode, deliveryInfoNote));
                if (Cookies.get("shop.trygg")) {
                    Cookies.remove("shop.trygg", { path: "/" });
                }
            } else {
                dispatch(trackCheckoutAndNavigate(GTM_ECOMMERCE_STEP.MEMBER, `${PAGES.CHECKOUT.SUMMARY.URL}`));
            }
        }
    };

    const continueButtonText = shouldSubmitorder
        ? TEXT.ADD_MEMBER.FINAL_USER_SUBMIT_ORDER
        : !isDigitalDelivery
          ? TEXT.ADD_MEMBER.CONTINUE_BUTTON.SUMMARY_WITH_DELIVERY
          : TEXT.ADD_MEMBER.CONTINUE_BUTTON.SUMMARY;

    return (
        <Button
            className="beta-checkout__continue-button-container__button"
            id="contact-info-form-button"
            form={FORM_ID.ADD_MEMBER}
            type="submit"
            loading={isNavigating}
            disabled={(!showAddMemberInputFields && hasDraftSubscriptions) || isFetchingData || isNavigating}
            onClick={handleOnContinue}
        >
            {continueButtonText}
        </Button>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    isFetchingData: LOADING_SELECTORS.isLoading(state),
    isNavigating: NAVIGATION_SELECTORS.isNavigating(state),
    showAddMemberInputFields: showAddMemberInputFieldsSelector(state),
    hasDraftSubscriptions: hasDraftMobileSubscriptionsSelector(state),
    hasOnlyServiceSubscriptions: hasOnlyServiceSubscriptionsSelector(state),
    totalPaymentPrice: getTotalPaymentPrice(state),
    draftSubscriptions: getAllItemsOfType(state, CART_ITEM_TYPE_CONST.SUBSCRIPTION_DRAFT),
    isDigitalDelivery: isDigitalDeliverySelector(state),
    deliveryInfoType: DELIVERY_INFO_SELECTORS.getDeliveryInfoType(state),
    deliveryInfoCode: DELIVERY_INFO_SELECTORS.getDeliveryInfoCode(state),
    deliveryInfoNote: DELIVERY_INFO_SELECTORS.getDeliveryInfoNote(state),
});

export default connect(mapStateToProps)(AddMemberContinueButton);
